
import './ProfileSection.scss';
export default function ProfileSection(props: any) {
    return (
        <section data-testid="profiles-wrapper " className="sc-drMfKT jBKKWJ ">{props.children}</section>
    );
}